import {createTheme} from "@mui/material";
import {KeyboardArrowDownRounded} from "@mui/icons-material";

const theme = (mode) => ({
    direction: "rtl",
    palette: {
        mode,
        ...(mode === 'light'
            ? {
                // palette values for light mode
                primary: {
                    main: "#2196F3",
                    dark: "#1565c0",
                    light: "#b3e5fc",
                },
                secondary: {
                    main: "#b3e5fc"
                },
                background: {
                    default: "#f5f5f5",
                    paper: "#ffffff",
                    box: "#ffffff",
                },
                text: {
                    primary: "#212121"
                },
                dark: {
                    main: "#212121",
                    focus: "#000"
                },
                light: {
                    main: "#fafafa",
                    focus: "#fff"
                },
                grey: {
                    dark: "#757575",
                    main: "#EAEAEA",
                    light: "#d1d1d1",
                }

            }
            : {
                // palette values for dark mode
                primary: {
                    main: "#2196F3",
                    dark: "#1565c0",
                    light: "#b3e5fc",
                },
                secondary: {
                    main: "#b3e5fc"
                },
                background: {
                    default: "#0d47a1",
                    box: "#252525"
                },
                text: {
                    primary: "#fafafa"
                },
                dark: {
                    main: "#212121",
                    focus: "#000"
                },
                light: {
                    main: "#fafafa",
                    focus: "#fff"
                },
                grey: {
                    dark: "#757575",
                    main: "#909095",
                    light: "#585858",
                }
            }),
    },
    typography: {
        fontFamily: [
            "IRANSans",
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        h6: {
            fontSize: "1.3rem",
            fontWeight: 600,
        }
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 360,
            md: 750,
            lg: 990,
            xl: 1200,
            xxl: 1400,
        },
    },
    shadows: [...createTheme({}).shadows.map((shadow, i) => (
        // Overwrite existing shadows
        // i === 1 ? '0 0 18px 0 rgba(9, 32, 46, 0.2)' : shadow
        shadow)),
        // Add new shadows
        '-2px 2px 26px rgba(33, 33, 33, 0.2)'
    ],
    components: {
        MuiContainer: {
            defaultProps: {
                maxWidth: "xxl"
            }
        },
        MuiPaper: {
            defaultProps: {
                elevation: 25,
            }
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    "& .MuiFormLabel-root": {
                        fontSize: ".9rem"
                    },
                    "& .MuiInputBase-input": {
                        "&::placeholder": {
                            fontSize: ".8rem",
                        }
                    }
                }
            }
        },
        MuiCssBaseline: {
            styleOverrides: `body, html {transition: background-color .2s ease-in-out;}`
        },
        MuiSelect: {
            defaultProps: {
                IconComponent: KeyboardArrowDownRounded,
            },
        },
    },
});
export default theme;